<template>
    <div class="m-addTheoryByManual">

        <!-- 导入组卷 -->
        <keep-alive>
            <add-theory-by-import
                ref="addTheoryByImport"
                v-if="isImport && !paperData.length"
                :knowledgeName="knowledgeName"
                :forLevel="forLevel"
                :difficulty="difficulty"
                @import-success="importSuccess"
            ></add-theory-by-import>
        </keep-alive>

        <div v-if="!isImport && !paperData.length" class="manual-no-topic">
            <p>{{$t('paper.clickBtnAddTopic')}}</p>
            <div class="btn-group">
                <el-button type="primary" @click="dialogOpen">{{$t('paper.addTopic')}}</el-button>
            </div>
        </div>

        <div v-if="paperData.length" class="paper-container">
            <aside class="paper-aside">
                <sticky :stickyTop="130" scroller=".sub-page .el-main">
                    <div class="paper-aside-wrap">
                        <div class="paper-aside-box category">
                            <!-- 单选题数量 -->
                            <div v-show="count.single">
                                <p>{{$t('paper.single')}}：{{count.single}} {{$t('paper.dao')}}</p>
                                <p>{{$t('paper.eachTopic')}}：
                                    <el-input-number
                                        v-model="score.single" size="mini" :min="1" :max="50"></el-input-number>
                                    {{$t('paper.points')}}
                                </p>
                            </div>

                            <!-- 多选题数量 -->
                            <div v-show="count.multi">
                                <p>{{$t('paper.multiple')}}：{{count.multi}} {{$t('paper.dao')}}</p>
                                <p>{{$t('paper.eachTopic')}}：
                                    <el-input-number
                                        v-model="score.multi" size="mini" :min="1" :max="50"></el-input-number>
                                    {{$t('paper.points')}}
                                </p>
                            </div>

                            <!-- 判断题数量 -->
                            <div v-show="count.choice">
                                <p>{{$t('paper.trueOrFalse')}}：{{count.choice}} {{$t('paper.dao')}}</p>
                                <p>{{$t('paper.eachTopic')}}：
                                    <el-input-number
                                        v-model="score.choice" size="mini" :min="1" :max="50"></el-input-number>
                                    {{$t('paper.points')}}
                                </p>
                            </div>

                            <!-- 配对题数量 -->
                            <div v-show="count.match">
                                <p>{{$t('paper.matching')}}：{{count.match}} {{$t('paper.dao')}}</p>
                                <p>{{$t('paper.eachTopic')}}：
                                    <el-input-number
                                        v-model="score.match" size="mini" :min="1" :max="50"></el-input-number>
                                    {{$t('paper.points')}}
                                </p>
                            </div>
                        </div>
                        <div class="paper-aside-box total">
                            <p>{{$t('paper.totalQuestions')}}：{{paperData.length}}</p>
                            <p>{{$t('paper.totalScores')}}：{{count.total}} {{$t('paper.points')}}</p>
                            <p>{{$t('paper.passScore')}}：{{count.pass}} {{$t('paper.points')}}</p>
                        </div>
                        <div class="btn-group btn-aside">
                            <el-button v-if="isImport" class="btn-other" @click="reimport" type="primary" plain>
                                <i class="nucfont inuc-daoru"></i>{{$t('paper.reimport')}}
                            </el-button>
                            <el-button v-else class="btn-other" @click="dialogOpen" type="primary" plain>
                                <i class="nucfont inuc-add-circle"></i>{{$t('paper.addTopic')}}
                            </el-button>

                            <el-button class="btn-other" @click="previewPaper" type="primary" plain>
                                <i class="nucfont inuc-preview"></i>{{$t('paper.previewPaper')}}
                            </el-button>

                            <el-button type="primary"
                                       class="btn-submit"
                                       @click="submitPaper"
                                       :loading="submitLoading"
                                       :disabled="!paperData.length">
                                <i class="nucfont inuc-step-right"></i>
                                {{$t('paper.savePaper')}}
                            </el-button>
                        </div>
                    </div>
                </sticky>
            </aside>

            <ul class="paper-list">
                <li v-for="(item, index) in paperData" :key="index">
                    <div class="detail" >
                        <!-- 题干 -->
                        <div class="topic-title">
                            <p class="type">
                                【
                                <template v-if="item.number">{{item.number}}，</template>
                                <template v-else>{{index+1}}，</template>
                                {{[$t('paper.single'), $t('paper.multiple'),
                                $t('paper.trueOrFalse'), $t('paper.matching')][item.type - 1]}}
                                】</p>
                            <p class="titleRT" v-html="item.titleRT"></p>
                        </div>

                        <!-- 选项 -->
                        <ul v-if="item.type < 4">
                            <li v-for="(v, i) in item.options" class="topic-choice" :class="{'rightAnswer': v.isRight}"
                                :key="i">
                                <el-radio v-if="item.type === 1" :value="true" :label="v.isRight">
                                    <em>{{v.tagName}}.</em>
                                    <div class="options" v-html="v.titleRT"></div>
                                </el-radio>
                                <el-checkbox v-if="item.type === 2" :value="v.isRight">
                                    <em>{{v.tagName}}.</em>
                                    <div class="options" v-html="v.titleRT"></div>
                                </el-checkbox>
                                <el-radio v-if="item.type === 3" :value="true" :label="v.isRight">
                                    <em>{{v.tagName}}</em>
                                </el-radio>
                            </li>
                        </ul>
                        <div class="match" v-if="item.type == 4">
                            <div class="image-wrap" >
                                <img :src="item.picViewUrl">
                            </div>
                            <div class="match-option">
                                <ul class="option-wrap">
                                    <li v-for="(item,index) in item.rectangleOptions" :key="'m'+item.id" class="option-item"> {{String.fromCharCode(index+65) + '. '+item.answerName}}</li>
                                </ul>

                            </div>
                        </div>
                    </div>
                    <div class="others">
                        <p class="answer"  v-if="item.type < 4"><span
                            class="tag">{{$t('paper.answer')}}：</span>{{item.id != 0 ? item.keyName : getAnswer(item)}}
                        </p>
                        <p class="analysis" v-html="
                            `<span class=tag>${$t('paper.analysis')}：</span>` + (item.analysisRT||$t('c.none')) "
                        ></p>
                    </div>
                    <div class="btn-operate">
                        <a class="btn-edit" @click="keyTopic(index)" :title="$t('paper.keyQuestion')">
                            <i class="nucfont inuc-favor" :class="{'inuc-favor-fill': item.isKey}"></i>
                        </a>
                        <a class="btn-edit"
                           v-if="trainerID === item.creatorID"
                           @click="editTopic(item, index)" :title="$t('paper.editPaper')">
                            <i class="nucfont inuc-edit"></i>
                        </a>
                        <el-popconfirm :title="$t('m.delete')" @confirm="deleteTopic(index)">
                            <a class="btn-delete" :title="$t('c.delete')" slot="reference">
                                <i class="nucfont inuc-delete"></i>
                            </a>
                        </el-popconfirm>
                    </div>
                </li>
            </ul>
        </div>

        <el-backtop target=".sub-page .el-main"></el-backtop>

        <topic-dialog
            v-if="true"
            v-model="topicSelector"
            :paperType="1"
            :init-ids="paperDataIds"
            :disableChecked="true"
            @on-save="addTopicDone"
        ></topic-dialog>

        <transition enter-active-class="animated slideInRight"
                    leave-active-class="animated slideOutRight">
            <router-view @onSave="editTopicSuccess"></router-view>
        </transition>

    </div>
</template>

<script>
    import api from '@/api'
    import {screenfull, Ticket} from '@/utils'
    import {mapGetters} from 'vuex'
    import AddTheoryByImport from "./AddTheoryByImport";
    import selectMultiKnowledge from '@/components/SelectMultiKnowledge'
    import selectMultiple from '@/components/Selectmultiple'
    import TopicDialog from "@/components/Dialog/TopicDialog"
    import sticky from '@/components/Sticky'

    export default {
        props: {
            isImport: {
                type: Boolean
            },
            passLine: {},
            paperName: {},
            knowledgeName: {},
            forLevel: {},
            difficulty: {},
            editData: {},
        },

        components: {
            AddTheoryByImport,
            selectMultiKnowledge,
            selectMultiple,
            sticky,
            TopicDialog
        },

        data() {
            return {
                options: [{
                    value: false,
                    label: this.$t('topic.examPaperLibrary')
                }, {
                    value: true,
                    label: this.$t('topic.myTopic')
                }],
                formSearch: {
                    number: '',
                    title: '',
                    forLevels: [],
                    difficulties: [],
                    types: [],
                    isOnlyMine: true,
                    knowledges: [0],
                },
                selectNames: [
                    {
                        key: "forLevel",
                    }, {
                        key: "difficulty",
                    }, {
                        key: "topicType",
                        onlyTheory: true
                    }],

                topicSelector: false,

                score: {
                    single: 0,
                    multi: 0,
                    choice: 0,
                    match: 0
                },
                paperData: [],
                submitLoading: false,

                trainerID: Ticket.get().userID,
            }
        },

        created() {
            if (this.editData) {
                let data = [...this.editData.relationship]

                data.forEach((val, index) => {
                    this.paperData.push(val.topic)
                    this.$set(this.paperData[index], 'isKey', val.key)

                    if (val.topic.type === 1) {
                        this.score.single = val.score
                    } else if (val.topic.type === 2) {
                        this.score.multi = val.score
                    } else if (val.topic.type === 3) {
                        this.score.choice = val.score
                    } else if (val.topic.type === 4) {
                        this.score.match = val.score
                    }
                })
            }
        },

        mounted() {

        },

        computed: {
            ...mapGetters([
                'knowledgeList',
            ]),
            paperDataIds() {
                if (this.paperData.length) {
                    return this.paperData.map(item => item.id)
                }
                return []
            },
            count() {
                let obj = {
                    single: this.paperData.filter(val => val.type === 1).length,
                    multi: this.paperData.filter(val => val.type === 2).length,
                    choice: this.paperData.filter(val => val.type === 3).length,
                    match: this.paperData.filter(val => val.type === 4).length,
                    total: 0,
                    pass: 0
                }

                obj.total = (this.score.single * obj.single + this.score.multi * obj.multi
                    + this.score.choice * obj.choice + this.score.match * obj.match).toFixed(2)
                obj.pass = (obj.total * this.passLine).toFixed(2)

                return obj
            },
        },
        methods: {
            importSuccess(data) {
                this.paperData = data
            },

            dialogOpen() {
                this.topicSelector = true
            },
            addTopicDone(ids, data) {
                let newData = data.filter(item => !this.paperDataIds.includes(item.id))
                this.paperData = this.paperData.concat(newData)
            },

            keyTopic(index) {
                this.$set(this.paperData[index], 'isKey', !this.paperData[index].isKey)
            },
            editTopic(item, index) {
                if(item.type == 4){
                    let name = this.editData ? 'editPaperMatchEditTopic' : 'addTheoryPaperEditTopic'
                    this.$router.push({name, params: {topic: item, topicIndex: index}})

                }else{
                    let name = this.editData ? 'editTheoryPaperEditTopic' : 'addTheoryPaperEditTopic'
                    this.$router.push({name, params: {topic: item, topicIndex: index}})

                }

                // editMatchTopic
            },
            editTopicSuccess(data, index) {
                Object.assign(this.paperData[index], data)
            },
            deleteTopic(index) {
                this.paperData.splice(index, 1)
            },

            getAnswer(item) {
                let rst = ''

                if (item.type === 3) {
                    rst = item.options.find(ele => ele.tag === 1).isRight ? this.$t('c.right') : this.$t('c.wrong')
                } else {
                    item.options.forEach(val => {
                        if (val.isRight) rst += `,${val.tagName}`
                    })
                    rst = rst.substring(1)
                }

                return rst
            },

            lastStep() {
                this.$emit('last-step')
            },
            reimport() {
                this.$confirm(this.$t('m.paperDataNotSave'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    this.paperData = []
                    this.$nextTick(() => {
                        this.$refs.addTheoryByImport.clearFile()
                    })
                }).catch(() => {
                })
            },

            formatPaper() {
                let submitData = {
                    passLine: this.passLine,
                    title: this.paperName,
                    knowledge: this.knowledgeName[this.knowledgeName.length - 1],
                    forLevel: this.forLevel,
                    difficulty: this.difficulty,
                    relationship: []
                }

                // 1. 导入组卷
                if (this.isImport) {

                    // 题目的拼装
                    this.paperData.forEach(val => {
                        let info = {}
                        info.topic = val
                        info.score = this.score[['single', 'multi', 'choice','match'][val.type - 1]]
                        info.key = val.isKey
                        //delete val.isKey;
                        submitData.relationship.push(info)
                    })

                    return submitData
                }

                // 2. 选题组卷 || 编辑模式
                this.paperData.forEach(val => {
                    let info = {}
                    info.topicID = val.id
                    info.score = this.score[['single', 'multi', 'choice','match'][val.type - 1]]
                    info.key = val.isKey
                    //delete val.isKey;
                    submitData.relationship.push(info)
                })

                return submitData
            },

            previewPaper() {
                let previewData

                previewData = this.formatPaper()

                Object.assign(previewData, {
                    totalScore: this.count.total,
                    singleScore: this.score.single,
                    multipleScore: this.score.multi,
                    tfScore: this.score.choice,
                    pairScore: this.score.match,
                    passScore: this.count.pass
                })

                if (!this.isImport) {
                    previewData.relationship.forEach(item => {
                        item.topic = this.paperData.find(v => v.id == item.topicID)
                    })
                }

                let name = this.editData ? 'editTheoryPaperPreview' : 'addTheoryPaperPreview'
                this.$router.push({name, params: {data: previewData}})
                screenfull.request()
            },

            submitPaper() {
                let submitData = this.formatPaper()
                //删除这个多余参数
                submitData.relationship.forEach(v => delete v.isKey)
                this.submitLoading = true

                // 1. 导入组卷
                if (this.isImport) {
                    api.addPaperByImport(submitData).then(res => {
                        this.submitSuccess()
                    }).catch(error => this.submitLoading = false)

                    return
                }

                if (this.editData) {
                    api.putPaper(this.editData.id, submitData).then(res => {
                        this.submitSuccess(this.$t('paper.editPaperSuccess') + '！')
                    }).catch(error => this.submitLoading = false)
                } else {
                    submitData.type = 1
                    api.postPaper(submitData).then(res => {
                        this.submitSuccess()
                    }).catch(error => this.submitLoading = false)
                }
            },

            submitSuccess(msg = this.$t('paper.theoryPaperMakeSuccess') + '！') {
                this.submitLoading = false
                this.$notify.success({
                    title: this.$t('c.success'),
                    message: msg,
                    type: 'success',
                    duration: 2000
                })
                this.$emit('needUpdate')
                this.$router.replace({name: 'myPaper'})
            },

            getForLevelVal(data) {
                this.formSearch.forLevels = data
            },
            getTopicTypeVal(data) {
                this.formSearch.types = data
            },
            getDifficultyVal(data) {
                this.formSearch.difficulties = data
            },
            knowledgeChange(data) {
                this.formSearch.knowledges = data
            },

            toTop() {
                this.$scrollElement.animate({scrollTop: 0}, 500)
            }
        },
        watch: {
            isImport(val) {
                this.paperData = []
            },
            // fix: 丢失参数的问题
            $route(to, from) {
                if (from.name === 'editTheoryPaperEditTopic' && to.params.paperId === ':paperId') {
                    let paperId = from.params.paperId
                    this.$router.replace({name: 'editTheoryPaper', params: {paperId}})
                }
            },
        },
    }
</script>

<style lang="scss">
    @import '~@/style/const';

    .m-addTheoryByManual {
        // 试题能够复用的css
        .paper-list {
            > li {
                position: relative;
                margin-bottom: 14px;
                padding: 15px 20px 10px 20px;
                color: #333;
                background-color: #f3f8ff;
                border-radius: 8px;
            }


            .detail {
                padding-right: 90px;

                .topic-title {
                    margin-bottom: 22px;
                    word-break: break-all;

                    .type {
                        margin-bottom: 6px;
                        color: #f4516c;
                    }

                    .titleRT {
                        padding-left: 5px;
                    }
                }

                .topic-choice {
                    display: flex;
                    margin-left: 25px;
                    margin-bottom: 12px;

                    em {
                        line-height: 1.5;
                        font-style: normal;
                    }

                    .options {
                        display: inline-block;
                        vertical-align: top;
                        white-space: normal;
                        word-break: break-all;
                        line-height: 1.5;
                        margin-left: 3px;
                    }
                }

            }
            .match{
                display: flex;
                .image-wrap {
                    width: 320px;
                    height: 233px;
                    margin-right: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #fff;

                    img {
                        max-height: 100%;
                    }
                }

                .match-option{
                    margin-top: 20px;
                    .option-item{
                        margin-bottom: 12px;
                    }
                }
            }

            .others {
                padding-left: 5px;
                border-top: dashed 1px #d8d8d8;

                .answer {
                    margin-top: 8px;
                    margin-bottom: 10px;
                }

                .tag {
                    color: #2e7faa;
                }
            }

            .btn-operate {
                position: absolute;
                right: 12px;
                top: 24px;

                a {
                    display: inline-block;
                    margin-right: 9px;
                    cursor: pointer;
                    color: #999;

                    .nucfont {
                        font-size: 18px;
                    }

                    &.btn-edit:hover,
                    .inuc-favor-fill {
                        color: $color-theme;
                    }

                    &.btn-delete:hover {
                        color: $c-danger;
                    }
                }
            }
        }

        .topic-title-content {
            /deep/ img {
                margin-top: 0 !important;
                max-height: 100px !important;
            }
        }
    }

</style>
